var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLink),expression:"showLink"}],attrs:{"href":_vm.link,"target":"_blank","data-html2canvas-ignore":"true"},on:{"click":_vm.goToSmartCenter}},[_c('img',{staticClass:"lightbulb",attrs:{"src":require("../assets/img/Bulb-Yellow.png"),"alt":_vm.smartCenterAlt}})])
}
var staticRenderFns = []

export { render, staticRenderFns }